import * as classnames from 'classnames'
import {LuminopiaGraphic} from 'core/components/LuminopiaLogo'
import {composeTheme} from 'core/utils/theme-helpers'
import * as React from 'react'
import * as classNames from './AppBar.css'

interface ITheme {
  container?: string
  graphicContainer?: string
  graphic?: string
  letteringContainer?: string
  lettering?: string
}

interface IProps {
  className?: string
  theme?: ITheme
}

/**
 * Header bar with Luminopia logo.
 */
class AppBar extends React.PureComponent<IProps, {}> {
  public render() {
    const {theme = {}} = this.props
    const containerClassName = classnames(
      this.props.className,
      theme.container,
    )
    return (
      <div className={containerClassName}>
        <div className={theme.graphicContainer}>
          <LuminopiaGraphic className={theme.graphic} />
        </div>
      </div>
    )
  }
}

export default composeTheme<IProps, {}, ITheme>(AppBar, classNames)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/AppBar/AppBar.tsx